import { cpOrderFormApiConnector } from 'apiConnector/secondary-market/cp-order/form';
import type { ModifyClientRequest } from 'apiConnector/secondary-market/cp-order/model';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap, takeUntil, withLatestFrom } from 'rxjs/operators';
import { secondaryMarketCpOrderClientInteractionFetchedThunk } from 'state/secondaryMarket/cpOrder/cpOrderForm/cpOrderForm.thunks';
import { secondaryMarketCpFormLinkedToClientFailed } from 'state/secondaryMarket/cpOrder/referential/client/client.actions';
import type { EpicWithThunk } from 'state/state.common';

import { getTabRemoved$ } from '../utils';

export function fetchLinkedToClientEpic(): EpicWithThunk {
  return (actions$, state$, { httpClient, selectors: { fromSecondaryMarket } }) => {
    const { getReferentialLinkedToClient } = cpOrderFormApiConnector(httpClient);

    return actions$.pipe(
      ofType('SECONDARY_MARKET_CP_FORM_LINKED_TO_CLIENT_FETCH_REQUESTED'),
      withLatestFrom(state$),
      mergeMap(([{ tabId }, state]) => {
        const request: ModifyClientRequest = fromSecondaryMarket.cpOrder.form.getModifyClientRequest(state, tabId);
        return getReferentialLinkedToClient(request).pipe(
          takeUntil(getTabRemoved$(actions$, tabId)),
          map(data => {
            return secondaryMarketCpOrderClientInteractionFetchedThunk(tabId, data);
          }),
          catchError((err: Error) => {
            return of(secondaryMarketCpFormLinkedToClientFailed(tabId, request.bcsProductKey, err.message));
          }),
        );
      }),
    );
  };
}
